import React from "react";
import "../../App.css";
import BranchMaster from "../BranchMaster";
import AccessDenied from "../AccessDenied";

function BranchMasterPage({ sessionObject }) {
  const hasAccess = sessionObject.sessionVariables["modules"]?.includes(
    "branch_master"
  );

  if (!hasAccess) {
    return (
      <div className="page-vehicle">
        <AccessDenied moduleName="Branch Master" />
      </div>
    );
  }

  return (
    <div className="page-vehicle">
      <BranchMaster sessionObject={sessionObject} />
    </div>
  );
}

export default BranchMasterPage;
